import Logo from "../assets/amabile.png";

export function Header() {
  const path = window.location.pathname;

  return (
    <div className="">
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img src={Logo} alt="Amabile" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarTogglerDemo02"
          >
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className={`nav-link ${
                    path === "/our-wines" ? "active" : ""
                  }`}
                  aria-current="page"
                  href="/our-wines"
                >
                  Our Wines
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${path === "/story" ? "active" : ""}`}
                  href="/story"
                >
                  Story
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${
                    path === "/community" ? "active" : ""
                  }`}
                  aria-disabled="true"
                  href="/community"
                >
                  Community
                </a>
              </li>
              <li className="nav-item">
                <a href="/where-to-buy">
                  <button>Where to Buy</button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
